module.exports = __webpack_public_path__ + "static/media/blog-single.3e0f8b2a.jpg";